import SiteShell from "../components/SiteShell";
import DiagramFlow from "../components/DiagramFlow";

const highlightCards = [
  {
    title: "Personal Loan in Under 3 Minutes",
    text: "Salaried customers can complete eligibility check, KYC and loan offer acceptance instantly at the kiosk.",
    image: "/image.png",
  },
  {
    title: "Built for Salaried Professionals",
    text: "Optimized journey for monthly-income users with salary validation and faster decision flows.",
    image: "https://images.pexels.com/photos/7252259/pexels-photo-7252259.jpeg",
  },
  {
    title: "Banking-Grade Security",
    text: "Enterprise-grade encryption, secure KYC, audit trails and controlled access at every step.",
    image: "/security_encryption_concept_1772861359511.png",
  },
];

const highlights = [
  { label: "Max Journey Time", value: "< 3 min" },
  { label: "Target Segment", value: "Salaried Only" },
  { label: "Security Standard", value: "Banking Grade" },
  { label: "Category Position", value: "1st in India" },
];

const trustBadges = ["Digital KYC Enabled", "Paperless Journey"];

const testimonials = [
  // {
  //   quote:
  //     "We saw quicker conversion from walk-in salaried applicants because the kiosk removed wait-time friction.",
  //   by: "Regional Lending Partner",
  // },
  // {
  //   quote:
  //     "Customers trust the flow because every step is clear, secure and very fast compared to desk-driven onboarding.",
  //   by: "Branch Operations Lead",
  // },
  // {
  //   quote:
  //     "Under-4-minute decision capability improved throughput during peak hours without increasing manpower.",
  //   by: "Distribution Head",
  // },

  {
    image: "/Khushi.jpeg",
    by: "Khushi Sharma",
    heading: "Customer Review",
    review:
      "The loan process was incredibly fast and simple. I completed everything within minutes without any hassle.",
  },
  {
    image: "/Ritika.jpeg",
    by: "Rashmi Rajput",
    heading: "Customer Review",
    review:
      "Great platform for salaried professionals. The process is simple and the approval time is surprisingly quick.",
  },
];

const whyChooseCards = [
  {
    stat: "50+",
    title: "Verified Lending Partners",
    text: "Compare curated offers from trusted banks and NBFCs through one streamlined kiosk journey.",
    image: "/whychoose1.png",
    theme: "light",
  },
  {
    stat: "10 Lakh+",
    title: "Happy Customers",
    text: "Helping salaried borrowers across India discover the right loan faster and with less friction.",
    image: "/whychoose.png",
    theme: "light",
  },
  {
    stat: "Pan-India",
    title: "Coverage Across India",
    text: "Designed for multi-city deployment with consistent experiences across branches and partner locations.",
    theme: "map",
  },
  {
    stat: "Data-First Platform",
    title: "Your Privacy Comes First",
    text: "Banking-grade security, encrypted workflows and controlled access across every step of the loan process.",
    image: "/security_encryption_concept_1772861359511.png",
    theme: "dark",
  },
];

const loanJourneySteps = [
  {
    title: "Enter Basic Details",
    text: "Add your mobile number, PAN and monthly income to begin the kiosk journey.",
    icon: "profile",
  },
  {
    title: "Verify Instantly",
    text: "Complete secure KYC, bank validation and eligibility checks in just a few taps.",
    icon: "upload",
  },
  {
    title: "Accept & Get Funds",
    text: "Review the offer, e-sign digitally and receive disbursal to your bank account.",
    icon: "check",
  },
];

function Home() {
  return (
    <SiteShell
      route="home"
      heroTag="Innovation Leader"
      heroTitle="Indis's first loan ATM"
      heroText="Empowering salaried individuals with a zero-friction and zero-paperwork personal loan journey. Experience banking-grade security and instant approvals in under 3 minutes, with loan amount starting from 10K to 1 Lakhs."
      // heroImage="https://www.dieboldnixdorf.com/-/media/diebold/video/dn_video_20210212_banking-solutions_v5.mp4"
      heroImage="/HomePage.png"
      heroQrImage="https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=https%3A%2F%2Fwww.instagram.com%2Ffinncube_credit%3Futm_source%3Dqr%26igsh%3DMW1oM2E1ZGY3aWE4"
      heroActions={[
        // { label: "Apply Now", href: "#/banking", primary: true },
        // { label: "Our Vision", href: "#/company" },
      ]}
    >
      {/* <section className="mx-auto max-w-[1280px] px-6 py-12 md:px-10">
        <div className="flex flex-wrap items-center justify-center gap-4 rounded-[40px] border border-slate-100 bg-white/50 p-6 shadow-xl backdrop-blur-md md:justify-between lg:px-10">
          {trustBadges.map((item) => (
            <div
              key={item}
              className="flex items-center gap-2 rounded-2xl bg-[#082f52]/90 px-6 py-4 text-center text-[10px] font-black uppercase tracking-[0.2em] text-white transition-all hover:bg-white hover:shadow-lg"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-[#e37921]" />
              {item}
            </div>
          ))}
        </div>
      </section> */}

  <section className="mx-auto max-w-[1280px] px-4 py-10 sm:px-6 md:px-10 md:py-12">
  <div className="flex flex-wrap items-center justify-center gap-4 rounded-[32px] border border-slate-100 bg-white/50 p-4 shadow-xl backdrop-blur-md sm:gap-6 sm:p-6 md:rounded-[40px] md:p-8 lg:px-12">
    
    {trustBadges.map((item) => (
      <div
        key={item}
        className="flex w-full items-center justify-center gap-3 rounded-2xl bg-[#082f52]/90 px-5 py-4 text-center text-xs font-bold uppercase tracking-[0.14em] text-white transition-all hover:bg-white/50 hover:text-[#082f52] hover:shadow-lg sm:w-auto sm:px-8 sm:py-5 sm:text-sm sm:tracking-[0.2em]"
      >
        <span className="h-2 w-2 rounded-full bg-[#e37921]" />
        {item}
      </div>
    ))}

  </div>
</section>

      <section className="mx-auto max-w-[1280px] px-4 py-12 sm:px-6 sm:py-14 md:px-10 md:py-16">
        <img
          src="/kiosk 1.jpg"
          alt="FinnCube kiosk"
          className="h-auto w-full rounded-[32px] border border-slate-200 object-cover shadow-[0_40px_80px_-20px_rgba(0,0,0,0.12)] md:rounded-[40px]"
        />
      </section>

      <DiagramFlow
        title="Salaried Loan Kiosk Journey"
        subtitle="Our tightly optimized flow is engineered for maximum throughput and uncompromising data integrity."
        steps={[
          {
            title: "Smart Input",
            text: "Guided interface for seamless data entry with real-time field validation.",
          },
          {
            title: "Verify Instantly",
            text: "Multi-layered KYC checks via secure government and banking APIs.",
          },
          {
            title: "Expert Decision",
            text: "Advanced risk engine evaluates profiles based on salary and credit rules.",
          },
          {
            title: "Final Approval",
            text: "Clear offer presentation with immediate digital consent mapping.",
          },
        ]}
      />

      <section className="mx-auto max-w-[1280px] px-4 py-14 sm:px-6 sm:py-16 md:px-10 md:py-20">
        <div className="grid gap-10 sm:gap-12 md:grid-cols-[1fr_1.1fr] md:gap-16">
          <div className="relative group">
            <div className="absolute -inset-2 rounded-[40px] bg-gradient-to-br from-[#df1f2d] to-navy opacity-10 blur-xl" />
            <img
              src="/user_verification_close_up_1772861182149.png"
              alt="Technology showcase"
              className="relative h-[280px] w-full rounded-[32px] border border-slate-200 object-cover shadow-2xl transition duration-500 group-hover:scale-[1.01] sm:h-[360px] md:h-[420px] lg:h-[450px] lg:rounded-[40px]"
            />
          </div>
          <div className="flex flex-col justify-center">
            <p className="text-xs font-black uppercase tracking-[0.18em] text-[#e37921] sm:text-[15px] sm:tracking-[0.25em]">
              Innovation in FinnCube
            </p>
            <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-4xl md:mt-6 md:text-5xl">
              Unmatched Speed and Accessibility
            </h2>
            <p className="mt-6 text-sm leading-relaxed text-slate-500 sm:text-base md:mt-8">
              We've bridged the gap between traditional banking trust and modern
              digital speed, providing a premium physical touchpoint for
              critical financial needs.
            </p>
            <div className="mt-8 space-y-4 sm:mt-10 sm:space-y-5 md:mt-12 md:space-y-6">
              {[
                "Accelerated application-to-disbursement ratio",
                "Advanced biometrics and data encryption",
                "Human-centric UX for streamlined outcomes",
              ].map((point) => (
                <div key={point} className="flex items-start gap-4">
                  <div className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green-50 text-green-600">
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={3}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <span className="text-sm font-semibold text-[#17385d] sm:text-base">
                    {point}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-14 sm:px-6 sm:py-16 md:px-10 md:py-24">
        <div className="grid gap-6 sm:gap-8 md:grid-cols-2 lg:grid-cols-3">
          {highlightCards.map((card) => (
            <article
              key={card.title}
              className="group relative overflow-hidden rounded-[32px] border border-slate-100 bg-white p-2 shadow-xl transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_48px_80px_-20px_rgba(10,44,79,0.15)]"
            >
              <div className="relative h-64 overflow-hidden rounded-[24px]">
                <img
                  src={card.image}
                  alt={card.title}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              </div>
              <div className="p-5 sm:p-6 md:p-8">
                <h3 className="text-xl font-bold tracking-tight text-[#0a2c4f] sm:text-2xl">
                  {card.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-500">
                  {card.text}
                </p>
                <div className="mt-8 h-1 w-0 bg-[#e37921] transition-all duration-500 group-hover:w-full" />
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-14 pb-20 sm:px-6 sm:py-16 sm:pb-24 md:px-10 md:py-20 md:pb-32">
        <div className="grid gap-10 sm:gap-12 lg:grid-cols-2 lg:gap-16">
          <div className="flex flex-col justify-center">
            <span className="text-xs font-black uppercase tracking-[0.2em] text-[#e37921] sm:text-[15px] sm:tracking-[0.3em]">
              Operational Excellence
            </span>
            <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-4xl md:mt-6 md:text-5xl lg:text-6xl">
              Built for Scale. <br />
              Deployed for Impact.
            </h2>
            <p className="mt-6 text-sm leading-relaxed text-slate-500 sm:text-base md:mt-8 md:text-lg">
              Our platform isn't just a kiosk; it's a complete lending
              ecosystem. From real-time risk evaluation to national-scale
              deployment monitoring, we provide the infrastructure for the next
              generation of physical fintech.
            </p>

            <div className="mt-8 grid grid-cols-1 gap-5 sm:mt-10 sm:grid-cols-2 sm:gap-6 md:mt-12 md:gap-8">
              {highlights.map((h) => (
                <div
                  key={h.label}
                  className="border-l-2 border-[#e37921]/20 pl-6 group"
                >
                  <p className="text-[10px] font-black uppercase tracking-widest text-slate-400 group-hover:text-[#e37921] transition-colors">
                    {h.label}
                  </p>
                  <p className="mt-1 text-2xl font-black text-[#0a2c4f]">
                    {h.value}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* <div className="relative group">
            <div className="absolute -inset-4 bg-[#df1f2d] opacity-[0.03] blur-3xl rounded-[48px]" />
            <div className="relative overflow-hidden rounded-[32px] border border-slate-100 bg-white p-5 shadow-2xl sm:p-6 md:rounded-[48px] md:p-12">
              <div className="mb-6 flex items-center justify-between md:mb-8">
                <div className="flex gap-2">
                  <div className="h-3 w-3 rounded-full bg-red-400" />
                  <div className="h-3 w-3 rounded-full bg-yellow-400" />
                  <div className="h-3 w-3 rounded-full bg-green-400" />
                </div>
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Live Risk Engine</span>
              </div>
              <div className="space-y-6 font-mono text-[11px]">
                <div className="p-4 rounded-xl bg-slate-50 border border-slate-100/50">
                  <p className="text-[#0a2c4f]/40 uppercase text-[9px] font-bold mb-2">Transaction ID: #KX-9942</p>
                  <p className="text-[#0a2c4f] font-bold">Initiating biometric identity match...</p>
                  <div className="mt-3 h-1.5 w-full bg-slate-200 rounded-full overflow-hidden">
                    <div className="h-full w-2/3 bg-[#df1f2d] rounded-full animate-pulse" />
                  </div>
                </div>
                <div className="p-4 rounded-xl bg-slate-50 border border-slate-100/50">
                  <p className="text-[#0a2c4f]/40 uppercase text-[9px] font-bold mb-2">Salary API Response</p>
                  <p className="text-green-600 font-bold">HTTP 200: Verified • Monthly Net: ₹85,000</p>
                </div>
                <div className="p-4 rounded-xl bg-[#0a2c4f] shadow-lg">
                  <p className="text-white/40 uppercase text-[9px] font-bold mb-2">Approval Engine</p>
                  <p className="text-white font-bold">STATUS: ELIGIBLE • OFFER: ₹4.5L @ 11.2%</p>
                </div>
              </div>
            </div>
          </div> */}
          <div className="relative group">
            <div className="absolute -inset-4 bg-[#df1f2d] opacity-[0.03] blur-3xl rounded-[48px]" />

            <div className="relative overflow-hidden rounded-[48px] bg-white border border-slate-100 shadow-2xl p-8 md:p-12">
              <div className="flex items-center justify-between mb-8">
      {/* <div className="flex gap-2">
        <div className="h-3 w-3 rounded-full bg-red-400" />
        <div className="h-3 w-3 rounded-full bg-yellow-400" />
        <div className="h-3 w-3 rounded-full bg-green-400" />
      </div> */}

      <span className="text-[15px] font-bold text-slate-400 uppercase tracking-widest">
        Live operations
      </span>
    </div>
              {/* Video Section */}
              <div className="overflow-hidden rounded-2xl">
                <video
                  className="pointer-events-none w-full h-full object-cover rounded-2xl"
                  autoPlay
                  muted
                  loop
                  playsInline
                  disablePictureInPicture
                  controlsList="nodownload nofullscreen noremoteplayback"
                >
                  <source src="/kiosk.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 pb-20 sm:px-6 sm:pb-24 md:px-10 md:pb-28">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-3xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-4xl md:text-5xl">
              Why Choose <span className="text-[#e37921]">FinnCube</span>
            </h2>
            <p className="mt-4 text-base font-medium text-slate-500 sm:text-lg">
              Smart borrowing infrastructure trusted by branches, partners and
              salaried customers across India.
            </p>
          </div>

          <div className="mt-10 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
            {whyChooseCards.map((card) => (
              <article
                key={card.title}
                className={`relative flex min-h-[460px] flex-col overflow-hidden rounded-[32px] border p-6 shadow-lg transition-transform hover:-translate-y-1 ${
                  card.theme === "dark"
                    ? "border-[#0a2c4f] bg-[#0a2c4f] text-white"
                    : "border-white/70 bg-white/60 text-[#0a2c4f] backdrop-blur-sm"
                }`}
              >
                <div className="relative z-10">
                  <p
                    className={`text-3xl font-extrabold tracking-tight ${
                      card.theme === "dark" ? "text-[#ffd089]" : "text-[#e37921]"
                    }`}
                  >
                    {card.stat}
                  </p>
                  <h3
                    className={`mt-4 text-2xl font-bold leading-tight ${
                      card.theme === "dark" ? "text-white" : "text-[#0a2c4f]"
                    }`}
                  >
                    {card.title}
                  </h3>
                  <p
                    className={`mt-5 text-lg leading-relaxed ${
                      card.theme === "dark"
                        ? "text-slate-100/90"
                        : "text-slate-600"
                    }`}
                  >
                    {card.text}
                  </p>
                </div>

                {card.theme === "map" ? (
                  <div className="relative mt-auto flex min-h-[180px] items-end justify-center pt-10">
                    <div className="absolute inset-x-6 bottom-6 top-10 rounded-[28px] border border-[#e7eef8] bg-[radial-gradient(circle_at_center,rgba(10,44,79,0.08),transparent_65%)]" />
                    <svg
                      viewBox="0 0 240 200"
                      className="relative z-10 h-44 w-full max-w-[220px] text-[#9ab3d6]"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M112 18 130 30 146 26 155 38 172 44 176 63 191 74 185 92 197 111 183 126 182 147 164 151 151 167 133 165 120 180 104 171 88 176 74 160 57 158 52 139 38 130 43 109 30 92 41 77 39 58 56 49 66 33 85 35 96 22 112 18Z"
                        stroke="currentColor"
                        strokeWidth="3"
                      />
                      {[
                        [98, 44],
                        [120, 66],
                        [89, 88],
                        [142, 86],
                        [154, 116],
                        [112, 120],
                        [82, 136],
                        [124, 154],
                        [96, 104],
                        [63, 111],
                      ].map(([cx, cy], index) => (
                        <circle
                          key={index}
                          cx={cx}
                          cy={cy}
                          r="4"
                          fill="#e37921"
                        />
                      ))}
                      <path
                        d="M98 44 120 66 142 86 154 116 124 154M120 66 96 104 82 136M89 88 63 111 82 136M96 104 112 120 154 116"
                        stroke="#0a2c4f"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                ) : (
                  <div className="relative mt-auto pt-10">
                    <div
                      className={`absolute inset-x-0 bottom-0 top-10 rounded-[28px] ${
                        card.theme === "dark"
                          ? "bg-white/5"
                          : "bg-gradient-to-t from-sky-100/80 to-transparent"
                      }`}
                    />
                    <img
                      src={card.image}
                      alt={card.title}
                      className={`relative z-10 mx-auto h-48 w-full max-w-[240px] object-contain ${
                        card.theme === "dark" ? "drop-shadow-2xl" : ""
                      }`}
                    />
                  </div>
                )}
              </article>
            ))}
          </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 pb-20 sm:px-6 sm:pb-24 md:px-10 md:pb-28">
        <div className="relative overflow-hidden rounded-[44px] bg-[radial-gradient(circle_at_top_left,rgba(227,121,33,0.12),transparent_26%),radial-gradient(circle_at_left_center,rgba(10,44,79,0.08),transparent_34%),linear-gradient(90deg,#f8fbff_0%,#ffffff_42%,#ffffff_100%)] px-6 py-12 sm:px-8 md:px-10 md:py-16">
          <div className="mx-auto max-w-4xl text-center">
            <h2 className="text-4xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-5xl md:text-6xl">
              Your <span className="text-[#e37921]">Loan Journey</span>
            </h2>
            <p className="mt-5 text-2xl font-semibold text-[#0a2c4f] sm:text-3xl">
              Get your loan approved in 3 simple steps
            </p>
          </div>

          <div className="relative mt-14">
            <svg
              viewBox="0 0 1200 420"
              className="pointer-events-none absolute left-0 top-0 hidden h-full w-full lg:block"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M410 170 C470 240, 560 240, 620 170"
                stroke="#98abc3"
                strokeWidth="2.5"
                strokeDasharray="10 12"
                strokeLinecap="round"
              />
              <path
                d="M820 120 C900 60, 980 60, 1050 120"
                stroke="#98abc3"
                strokeWidth="2.5"
                strokeDasharray="10 12"
                strokeLinecap="round"
              />
              <path
                d="M1070 215 C1115 320, 1010 390, 880 405"
                stroke="#98abc3"
                strokeWidth="2.5"
                strokeDasharray="10 12"
                strokeLinecap="round"
              />
            </svg>

            <div className="grid gap-6 lg:grid-cols-3">
              {loanJourneySteps.map((step, index) => (
                <div key={step.title} className="relative">
                  <article className="relative z-10 rounded-[28px] border border-[#dbe4ef] bg-[linear-gradient(180deg,rgba(250,251,255,0.98)_0%,rgba(255,255,255,0.98)_100%)] px-8 py-8 shadow-[0_24px_60px_-40px_rgba(10,44,79,0.35)]">
                    <div className="flex items-center gap-6">
                      <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-full border-2 border-[#c2cfde] bg-white shadow-[inset_0_0_0_8px_rgba(246,249,253,0.95)]">
                        {step.icon === "profile" && (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-9 w-9 text-[#0a2c4f]"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                          >
                            <path d="M8 4.5h6l3 3V19H8z" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 4.5v3h3" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M10.5 12h4" strokeLinecap="round" />
                            <path d="M10.5 15.5h4" strokeLinecap="round" />
                          </svg>
                        )}
                        {step.icon === "upload" && (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-9 w-9 text-[#0a2c4f]"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                          >
                            <path d="M12 16V6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="m8.5 9.5 3.5-3.5 3.5 3.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 17.5v2h12v-2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        )}
                        {step.icon === "check" && (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-9 w-9 text-[#0a2c4f]"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                          >
                            <path d="m6.5 12.5 3 3 8-8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="m11 12.5 2.5 2.5 4.5-4.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        )}
                      </div>

                      <div>
                        <h3 className="text-[24px] font-semibold leading-tight text-[#0a2c4f] sm:text-[26px]">
                          {step.title}
                        </h3>
                        <p className="mt-3 max-w-[260px] text-xl leading-snug text-slate-600">
                          {step.text}
                        </p>
                      </div>
                    </div>
                  </article>

                  {index === 0 && (
                    <div className="absolute -bottom-6 right-[-34px] z-20 hidden h-10 w-10 items-center justify-center rounded-full bg-[#0a2c4f] text-xl text-white lg:flex">
                      ›
                    </div>
                  )}
                  {index === 1 && (
                    <div className="absolute -top-12 right-[-34px] z-20 hidden h-10 w-10 items-center justify-center rounded-full bg-[#0a2c4f] text-xl text-white lg:flex">
                      ›
                    </div>
                  )}
                  {index === 2 && (
                    <div className="absolute bottom-[-96px] right-[78px] z-20 hidden h-12 w-12 items-center justify-center rounded-full bg-[#0a2c4f] text-white lg:flex">
                      <svg
                        viewBox="0 0 24 24"
                        className="h-6 w-6"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      >
                        <path d="M12 7v5l3 2" strokeLinecap="round" strokeLinejoin="round" />
                        <circle cx="12" cy="12" r="8" />
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="mx-auto mt-14 grid max-w-[900px] overflow-hidden rounded-[34px] bg-[#0a2c4f] shadow-[0_30px_80px_-35px_rgba(16,48,95,0.7)] lg:grid-cols-[1.12fr_0.88fr]">
              <div className="relative p-8 sm:p-10 md:p-12">
                <div className="absolute right-[-80px] top-10 h-72 w-72 rounded-full border-[56px] border-[#163f68]" />
                <div className="absolute right-16 top-20 h-3 w-3 rounded-full bg-white/15" />
                <div className="absolute right-28 top-36 h-2.5 w-2.5 rounded-full bg-white/15" />
                <div className="relative z-10">
                  <div className="flex h-20 w-20 items-center justify-center rounded-3xl bg-white/12">
                    <div className="flex h-14 w-14 items-center justify-center rounded-full border-4 border-white bg-[#e37921] text-white">
                      <svg
                        viewBox="0 0 24 24"
                        className="h-8 w-8"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                      >
                        <path d="m6 12 4 4 8-8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                  <h3 className="mt-8 text-5xl font-extrabold tracking-tight text-white sm:text-6xl">
                    Rs 1,00,000
                  </h3>
                  <p className="mt-4 max-w-md text-[18px] leading-snug text-white/90 sm:text-[19px]">
                    Receive the approved loan amount directly in your account
                  </p>
                </div>
              </div>

              <div className="relative flex min-h-[320px] items-end justify-end overflow-hidden">
                <img
                  src="/whychoose.png"
                  alt="FinnCube loan approval"
                  className="relative z-10 h-full max-h-[340px] w-full object-cover object-bottom"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-14 pb-20 sm:px-6 sm:py-16 sm:pb-24 md:px-10 md:py-20 md:pb-40">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between lg:gap-10">
          <div className="max-w-xl lg:shrink-0">
            <h2 className="text-3xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-4xl md:text-5xl">
              Partner Trust. <br />
              Success Stories.
            </h2>
            <p className="mt-6 text-base text-slate-500">
              How we're transforming branch operations across the region with
              automated lending kiosks.
            </p>
          </div>
          <div className="flex w-full flex-col gap-5 md:flex-row md:items-stretch lg:-mt-6 lg:max-w-[760px] lg:justify-end">
            {testimonials.slice(0, 2).map((item) => (
              <article
                key={item.by}
                className="relative w-full overflow-hidden rounded-3xl border border-slate-100 bg-white p-1 shadow-lg transition-transform hover:-translate-y-1 md:max-w-[320px] lg:flex-1"
              >
                <span className="absolute -top-4 -left-2 text-6xl text-[#df1f2d]/10 pointer-events-none">
                  "
                </span>
                <img
                  src={item.image}
                  alt={item.by}
                  className="relative z-10 h-28 w-full rounded-xl object-cover sm:h-32"
                />
                <div className="mt-3 p-3 sm:p-4">
                  <p className="text-xs font-black uppercase tracking-widest text-[#0a2c4f]">
                    {item.by}
                  </p>
                  <h3 className="mt-3 text-sm font-bold text-[#0a2c4f] uppercase tracking-wider">
                    {item.heading}
                  </h3>

                  <p className="mt-2 text-sm text-slate-600 italic leading-relaxed">
                    {item.review}
                  </p>

                  {/* <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-1">
        {item.role}
      </p> */}
                </div>
                {/* <div className="mt-6 flex items-center gap-4"> */}
                {/* <div className="h-10 w-10 rounded-full bg-slate-100 overflow-hidden">
                    <div className="h-full w-full bg-gradient-to-tr from-slate-200 to-slate-50" />
                  </div> */}
                {/* <div> */}
                {/* <p className="text-xs font-black uppercase tracking-widest text-[#0a2c4f]">
                      {item.by}
                    </p> */}
                {/* <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-1">
                     "The loan process was incredibly fast and simple. I was able to complete everything within minutes without any hassle."
                    </p> */}
                {/* </div>
                </div> */}
              </article>
            ))}
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-[1280px] px-4 pb-20 sm:px-6 sm:pb-24 md:px-10 md:pb-32">
        <section className="relative overflow-hidden rounded-[36px] bg-[#0a2c4e] p-6 text-white shadow-2xl sm:p-8 md:rounded-[60px] md:p-24">
          <div className="absolute -right-20 -top-20 h-96 w-96 rounded-full bg-[#df1f2d] opacity-20 blur-[120px]" />
          <div className="absolute -left-20 -bottom-20 h-80 w-80 rounded-full bg-sky-500 opacity-10 blur-[100px]" />

          <div className="relative z-10 mx-auto max-w-4xl text-center">
            <span className="text-[10px] font-black uppercase tracking-[0.2em] text-sky-300 sm:tracking-[0.4em]">
              Scale Your Business Today
            </span>
            <h2 className="mt-6 text-3xl font-extrabold leading-tight sm:text-4xl md:mt-8 md:text-7xl">
              The Future of Physical Credit.
            </h2>
            <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-sky-100/70 sm:text-lg md:mt-10 md:text-xl">
              Join India's leading financial institutions in deploying the
              future of automated personal loan kiosks.
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4 sm:mt-12 sm:gap-5 md:mt-16 md:gap-6">
              {/* <a
                href="#/company"
                className="rounded-full bg-[#e37921] px-12 py-5 text-[11px] font-black uppercase tracking-[0.2em] text-white transition-all hover:-translate-y-2 hover:shadow-[0_20px_40px_-10px_rgba(223,31,45,0.6)] hover:bg-[#e37921]"
              >
                Get Started Now
              </a> */}
              <a
                href="#/software"
                className="rounded-full bg-[#e37921] px-8 py-3 text-[10px] font-black uppercase tracking-[0.12em] text-white transition-all hover:-translate-y-2 hover:shadow-[0_20px_40px_-10px_rgba(223,31,45,0.6)] hover:bg-[#e37921] sm:px-10 sm:py-4 sm:text-[11px] sm:tracking-[0.2em] md:px-12 md:py-5"
              >
                Explore Technology
              </a>
            </div>
          </div>
        </section>
      </div>
    </SiteShell>
  );
}

export default Home;
